import { TableName } from "../../../tables"
import { DeliveryMethod, DeliveryStatus } from "../state/types"

export enum DeliveryOrderStatusFilter {
    NOT_DELIVERED = 'NotDelivered',
    CANCELLED = 'Cancelled'
}

export enum DeliveryNoteStatusFilter {
    PENDING = 'Pending',
    DELIVERED = 'Delivered',
    CANCELLED = 'Cancelled'
}

export type DeliveryNoteFilters = {
    searchText?: string
    method?: DeliveryMethod
    table?: TableName
    customerId?: string
    status?: DeliveryNoteStatusFilter
    dateFrom?: Date
    dateTo?: Date
}

export type DeliveryOrderFilters = {
    currentBranchId?: string
    method: DeliveryMethod
    searchText?: string
    table?: TableName
    customerId?: string
    deliveryStatus?: DeliveryStatus | DeliveryOrderStatusFilter
    creationDateFrom?: Date
    creationDateTo?: Date
    dateFrom?: Date
    dateTo?: Date
}
